const storage = window.localStorage;

export default {
  store(key, value) {
    return storage.setItem(key, JSON.stringify(value));
  },
  read(key) {
    try {
      const value = storage.getItem(key);
      return JSON.parse(value);
    } catch (e) {
      return false;
    }
  },
  remove(key) {
    return storage.removeItem(key);
  },
  clear() {
    return storage.clear();
  },
};
